import { ComponentInfo } from "@builder.io/sdk-react";

export const CATEGORY_FILTERS_INPUTS = [
  {
    name: "subcategoriesWithProductCount",
    type: "list",
    subFields: [
      {
        name: "name",
        type: "string",
        defaultValue: "",
      },
      {
        name: "checked",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "uid",
        type: "string",
        defaultValue: "",
      },
      {
        name: "productCount",
        type: "number",
        defaultValue: "",
      },
      {
        name: "withSlug",
        type: "boolean",
        defaultValue: false,
      },
    ],
    defaultValue: [],
  },
] as const satisfies ComponentInfo["inputs"];

export type CategoryFiltersProps = BuilderComponentProps<
  typeof CATEGORY_FILTERS_INPUTS
>;
